<p-toast
  [breakpoints]="{ '500px': { width: '95%', right: '0', left: '8px' } }"
  class="custom-toast"
>
  <ng-template let-message pTemplate="message">
    <img [src]="imgPath" width="24px" />
    <span class="pl-10px">{{ message.summary }}</span>
  </ng-template>
</p-toast>
